import { callAuthedSupabaseFunction } from './api.ts'
import { supabase } from './supabase.ts'

async function adminAccessToken() {
  const { data } = await supabase.auth.getSession()
  const token = data.session?.access_token
  if (!token) throw new Error('Sign in again to continue.')
  return token
}

async function postAdminFunction(name: string, body: Record<string, unknown>) {
  const token = await adminAccessToken()
  const response = await callAuthedSupabaseFunction(name, token, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  const payload = await response.json() as { ok?: boolean; error?: string } & Record<string, unknown>
  if (!payload.ok) {
    throw new Error(payload.error || 'The admin request failed.')
  }
  return payload
}

export function updateAdminBooking(body: {
  bookingId: string
  customerName: string
  customerEmail: string
  customerPhone: string
  vehicleMake: string
  vehicleModel: string
  internalNotes: string
  appointmentDate: string
  appointmentTime: string
}) {
  return postAdminFunction('admin-bookings', { action: 'update', ...body })
}

export function cancelAdminBooking(bookingId: string) {
  return postAdminFunction('admin-bookings', { action: 'cancel', bookingId })
}

export function deleteTestAdminBooking(bookingId: string) {
  return postAdminFunction('admin-bookings', { action: 'delete', bookingId })
}

export function replyToEnquiry(enquiryId: string, body: string) {
  return postAdminFunction('admin-enquiry-reply', { action: 'reply', enquiryId, body })
}

export function closeEnquiry(enquiryId: string) {
  return postAdminFunction('admin-enquiry-reply', { action: 'close', enquiryId })
}
